import type { ReactElement } from 'react';
import { Component } from 'react';

import type { Logger } from '@shared/types/frontend/logger';
import type { Nullable } from '@shared/types/utils';

import { COMPONENTLOAD_FAILURE } from '@shared/constants/newrelic-events/event-names';
import { withLogging } from '@shared/utils-frontend/contexts/LoggingContext';
import updatedErrorStack from '@shared/utils-frontend/update-error-stack';

type Props = {
  errorPage: Nullable<string>;
  logger: Logger;
  children: ReactElement;
};

class AppErrorBoundary extends Component<Props> {
  componentDidCatch(
    error: Error,
    { componentStack }: { componentStack: string },
  ) {
    const { errorPage, logger } = this.props;
    const { error: updatedError, stackData } = updatedErrorStack(
      error,
      componentStack,
    );
    logger.event(COMPONENTLOAD_FAILURE);
    logger.error('Caught error in ErrorBoundary', stackData, updatedError);
    if (errorPage) {
      window.location.replace(errorPage);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withLogging(AppErrorBoundary);
